import { render, staticRenderFns } from "./AccountBrand.vue?vue&type=template&id=07631100&"
import script from "./AccountBrand.vue?vue&type=script&lang=js&"
export * from "./AccountBrand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports